module.exports = __webpack_public_path__ + "01890304aef8c2f19b7fbbed29c059d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/resources/imb-logo.svg
// module id = 642
// module chunks = 0 2